import { render, staticRenderFns } from "./PermissionSelect.vue?vue&type=template&id=41c7a1c6"
import script from "./PermissionSelect.vue?vue&type=script&lang=js"
export * from "./PermissionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports